/** Animated, structure-specific U-turn diagrams for the maneuver sign. */

import type { UturnStructure } from '../nav/uturnStructure';

/**
 * The route geometry decides which side the U-turn swings to. All diagrams are
 * authored with the return lane on the right and mirrored as one unit when the
 * actual road curves left.
 */
export function uturnGuideSvg(kind: Exclude<UturnStructure, 'unknown'>, turnSign: number): string {
  const mirror = turnSign < 0 ? ' transform="translate(120 0) scale(-1 1)"' : '';

  let scene: string;
  if (kind === 'under-bridge') {
    scene = `
      <path class="uturn-guide__surface" d="M12 5H108V94H12Z" />
      <path class="uturn-guide__ground" d="M30 91V49 M90 49V91" />
      <path class="uturn-guide__route" d="M30 91V53 C30 36 90 36 90 53V81" />
      <path class="uturn-guide__flow" pathLength="100" d="M30 91V53 C30 36 90 36 90 53V81" />
      <path class="uturn-guide__head" d="M82 73L90 83L98 73" />
      <path class="uturn-guide__pier-shadow" d="M46 17H74 M46 75H74" />
      <path class="uturn-guide__pier" d="M46 17H74 M46 75H74" />
      <path class="uturn-guide__bridge-shadow" d="M60 6V90" />
      <path class="uturn-guide__bridge-deck" d="M60 6V90" />
      <path class="uturn-guide__bridge-lane" d="M60 10V86" />
      <path class="uturn-guide__bridge-rail" d="M48 6V90 M72 6V90" />
    `;
  } else if (kind === 'bridge') {
    scene = `
      <path class="uturn-guide__surface uturn-guide__surface--ground" d="M9 4H111V94H9Z" />
      <path class="uturn-guide__ground uturn-guide__ground--faint" d="M25 91V5 M95 91V5" />
      <path class="uturn-guide__ground-lane" d="M60 91V5" />
      <path class="uturn-guide__pier-shadow" d="M35 48V86 M85 48V86" />
      <path class="uturn-guide__pier" d="M35 48V84 M85 48V84" />
      <path class="uturn-guide__bridge-bed-shadow" d="M34 91V44 C34 10 86 10 86 44V81" />
      <path class="uturn-guide__bridge-bed" d="M34 91V44 C34 10 86 10 86 44V81" />
      <path class="uturn-guide__route" d="M34 91V44 C34 10 86 10 86 44V81" />
      <path class="uturn-guide__flow" pathLength="100" d="M34 91V44 C34 10 86 10 86 44V81" />
      <path class="uturn-guide__head" d="M78 73L86 83L94 73" />
      <path class="uturn-guide__rail" d="M24 91V44 C24 -2 96 -2 96 44V81" />
    `;
  } else {
    scene = `
      <path class="uturn-guide__surface" d="M15 3H105V94H15Z" />
      <path class="uturn-guide__road-edge" d="M16 91V5 M104 91V5" />
      <path class="uturn-guide__median" d="M60 91V45 M60 15V5" />
      <path class="uturn-guide__lane" d="M34 91V5 M86 5V91" />
      <path class="uturn-guide__route" d="M34 91V36 C34 14 86 14 86 36V81" />
      <path class="uturn-guide__flow" pathLength="100" d="M34 91V36 C34 14 86 14 86 36V81" />
      <path class="uturn-guide__head" d="M78 73L86 83L94 73" />
    `;
  }

  return `<svg class="uturn-guide uturn-guide--${kind}" viewBox="0 0 120 96" aria-hidden="true" fill="none"><g${mirror}>${scene}</g></svg>`;
}
